/*
 * Purpose : Tool sales transaction landing page
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import React, { useState, useEffect, useContext } from "react";
import ReactTable from "react-table";
import {NavLink} from 'react-router-dom';
import Collapse from 'react-bootstrap/Collapse'
import moment from 'moment';
import numeral from 'numeral';
import {
  Button,
  Alert
} from "reactstrap";
// import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
// import { MdClose } from 'react-icons/md';
import { MdEdit, MdVisibility, MdDelete } from "react-icons/md";
//import { Col, FormGroup, Label, Input, Row, Form, FormFeedback } from "reactstrap";
import { Col, Row, Form } from "reactstrap";
import {FaSearch} from "react-icons/fa"
import {TiThMenu} from "react-icons/ti"
import Popup from 'reactjs-popup'; //TODO if dont use delete it


import "./ToolSalesTransactions.css";
import ToolSalesButton from '../../UI/Buttons/ToolSalesButton/ToolSalesButton';
import { toolSalesTransactionsTableHeader, approvalStages, generalConstants } from "../../../config/constants";
import LoadingModal from "../../../components/UI/modals/loadingModal";
import BackButton from '../../UI/Buttons/BackButton/BackButton';
import {ToolSalesFormService} from '../../../services/ToolSalesFormService';
import ToolStatusSearch from "../ToolStatusSearch/ToolStatusSearch";
import DeleteAlertModal from "../../UI/modals/DeleteAlertModal";
import AppContext from './../../../context/app-context';
import {colors} from './../../../styleConstants'
// import 'reactjs-popup/dist/index.css';

const formService = new ToolSalesFormService(); 

const ToolSalesTransactions = (props) => {
  const [loading, setLoading] = useState(false);
  const [declaredToolData, setDeclaredToolData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [modal, setModal] = useState(false);
  const [confirmError, setConfirmError] = useState(null)
  const [successAlert, setSuccessAlert] = useState(null)
  const [stateValues, setStateValues] = useState({});
  const[toolList, setToolList] = useState([])
  const[displaySearchDiv, setDisplaySearchDiv] = useState(false)
  const [row, setRow] = useState({})
  const [deleteModal, setDeleteModal] = useState(false)
      

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen(prevState => !prevState);

  const appContext = useContext(AppContext)  
  const toggleModal = () => setModal(!modal);  
  

  
  
  const askForDelete = (row) => {
    setRow(row)
    setDeleteModal(true)
  }
  // to handle transaction delete at row level
  const deleteAction = async (row) =>{
    //console.log("row=>",row)
    setLoading(true)
    setDeleteModal(false)
    let deleteFlag;
    try {
      deleteFlag = await formService.deleteHeaderData(row.transactionid)
      if(deleteFlag){
        await getTransactionOnLoadData()
        setSuccessAlert("Record was deleted successfully.!")
        setLoading(false)
      }else{
        throw Error("deleteFlag is coming as null")
      }
    } catch (error) {
      console.log("error in delete",error)
      setConfirmError("There is a technical error while fetching the details. Please try again..!")
      setLoading(false)
    }
  }  
  
  // to generate action buttons and add to respective rows
  const buildActions = (tableRow) => {
    const actions = [];
    //console.log("tableRow=>",tableRow)
    actions.push(
      <div>
        <Popup on={['hover','click']} trigger={<button type="button" className={"actionButton"}><TiThMenu style={{color:"rgb(251, 135, 52)"}}/></button>} position="right center">
          <div key={tableRow.id} className={"actionDiv"}>
            {
              tableRow.status==="APPROVED" ?
                <NavLink to={`/toolsales/viewform/${tableRow.transactionid}`} onClick={(e)=>e.preventDefault()}>                
                  <Button className={"actionBtnSalesTxn"} size="sm" outline disabled>
                    <MdVisibility style={{fontSize:"20px"}}/>
                  </Button>
                </NavLink>
                :
                <NavLink to={`/toolsales/viewform/${tableRow.transactionid}`} >
                  <Button className={"actionBtnSalesTxn"} size="sm" outline color="info" >
                    <MdVisibility style={{fontSize:"20px"}}/>
                  </Button>
                </NavLink>              
            }
            &nbsp;
            {
              ((tableRow.status === approvalStages.draft || tableRow.status.indexOf("Rejected") !== -1 || tableRow.status === approvalStages.approved) && (appContext.role === "Admin" || appContext.role === "Tool sales Creator" || appContext.user === tableRow.initiator))
              ?
              <NavLink to={`/toolsales/editform/${tableRow.transactionid}`} >
                <Button className={"actionBtnSalesTxn"} size="sm" outline color="warning" >
                  <MdEdit style={{fontSize:"20px"}}/>
                </Button>
              </NavLink>
              :
              <NavLink to={`/toolsales/editform/${tableRow.transactionid}`} onClick={(e)=>e.preventDefault()} >
                <Button className={"actionBtnSalesTxn"} size="sm" disabled>
                  <MdEdit style={{fontSize:"20px"}}/>
                </Button>
              </NavLink>
            }
            &nbsp;
            {
              ((tableRow.status === approvalStages.draft || tableRow.status.indexOf("Rejected") !== -1 || tableRow.status === approvalStages.cancelled) && (appContext.role === "Admin" || appContext.role === "Tool sales Creator" || appContext.user === tableRow.initiator))
              ?
              <Button className={"actionBtnSalesTxn"} size="sm" outline color="danger" onClick={() => askForDelete(tableRow)} >
                <MdDelete style={{fontSize:"20px"}}/>
              </Button>
              :
              <Button className={"actionBtnSalesTxn"} size="sm" disabled>
                <MdDelete style={{fontSize:"20px"}}/>
              </Button>
            }
            

          </div>
        </Popup>
        
      </div>
    );
    return actions;
  };

  // to get initial values
  const getTransactionOnLoadData = async () =>{
    const columns = [];
      Object.keys(toolSalesTransactionsTableHeader).forEach((col, i) => {
        if (col.toLowerCase() === "actions") {
          columns.push({
            Header: toolSalesTransactionsTableHeader[col],
            accessor: col,
            filterable: false,
            minWidth: 70,
            getProps: (state, rowInfo, column) => {
                return {
                    style: {
                        textAlign:"center"
                    },
                };
            }
            //headerClassName: 'wordwrap'
          });
        }else if(col === "deal_ref"){
          columns.push({
            Header: toolSalesTransactionsTableHeader[col],
            accessor: col,
            filterable: true,
            minWidth: 150,            
            Cell: e=> <span style={{color:colors.infoColor}}>{e.value}</span>
          })
        }else if(col === "initiator"){
          columns.push({
            Header: toolSalesTransactionsTableHeader[col],
            accessor: col,
            filterable: true,
            minWidth: 155,            
            Cell: e=> <span>{e.value}</span>
          })
        }
        else if(col === "date"){
          columns.push({
            Header: toolSalesTransactionsTableHeader[col],
            accessor: col,
            filterable: true,
            Cell: e=>moment(e.value).format("YYYY MMM D")
          })
        }else if(col === "total_price" || col === "total_nbv"){
          columns.push({
            Header: toolSalesTransactionsTableHeader[col],
            accessor: col,
            filterable: true,
            minWidth: 130,
            getProps: (state, rowInfo, column) => {
                return {
                    style: {
                        textAlign:"right"
                    },
                };
            },
            Cell: e=>numeral(e.value).format('0,0.00')
          })
        }
        else if(col === "total_gain_loss"){
          columns.push({
            Header: toolSalesTransactionsTableHeader[col],
            accessor: col,
            filterable: true,
            minWidth: 170,
            getProps: (state, rowInfo, column) => {
                return {
                    style: {
                        textAlign:"right"
                    },
                };
            },
            Cell: e=> numeral(e.value).value()<0 
                        ? <span style={{color:colors.dangerColor}}>{numeral(e.value).format('0,0.00')}</span>
                        : numeral(e.value).value()>0  
                        ? <span style={{"color":colors.successColor}}>{numeral(e.value).format('0,0.00')}</span>
                        : <span style={{"color":colors.infoColor}}>{numeral(e.value).format('0,0.00')}</span>

          })
        }else if(col === "status"){
          columns.push({
            Header: toolSalesTransactionsTableHeader[col],
            accessor: col,
            filterable: true,
            minWidth: 130,
            getProps: (state, rowInfo, column) => {
              //console.log("len=>",rowInfo?.row?.comment?.length) 
              // to make the data in the column wrap and size to small
              return {
                  style: {
                      whiteSpace:"unset",
                      fontSize: rowInfo?.row?.status?.length > 21 ? "smaller" : "small",
                      textAlign: "center"
                  },
              };
            },
            Cell: e=>{
              if(e.value?.trim().toLowerCase().indexOf("pending")!==-1){
                return <span style={{"color":colors.warningColor}}><b>{e.value?.trim()}</b></span>
              }else if(e.value?.trim().toLowerCase().indexOf("rejected")!==-1){
                return <span style={{"color":colors.dangerColor}}><b>{e.value?.trim()}</b></span>
              }
              else if(e.value?.trim()===approvalStages.draft){
                return <span style={{"color":colors.infoColor}}><b>{e.value?.trim()}</b></span>
              }else if(e.value?.trim()===approvalStages.cancelled){
                return <span style={{"color":colors.cancelColor}}><b>{e.value?.trim()}</b></span>
              }else{
                return <span style={{"color":colors.successColor}}><b>{e.value?.trim()}</b></span>
              }
            }
          })
        } else if(col === "comment"){
          columns.push({
            Header: toolSalesTransactionsTableHeader[col],
            accessor: col,
            filterable: true,
            minWidth: 250,            
            getProps: (state, rowInfo, column) => {
              //console.log("len=>",rowInfo?.row?.comment?.length) 
              // to make the data in the column wrap and size to small
              return {
                  style: {
                      whiteSpace:"unset",
                      fontSize: rowInfo?.row?.comment?.length > 30 ? "smaller" : "small"
                  },
              };
          },

          });
        }
        else {
          columns.push({
            Header: toolSalesTransactionsTableHeader[col],
            accessor: col,
            filterable: true,
            //headerClassName: 'wordwrap'            
          });
        }
      });
      setColumns(columns);


      let toolTxnList;
      try {
        toolTxnList = await formService.getTransactionDetails(appContext.user)
        //console.log("toolTxnList==>",toolTxnList)  
      } catch (error) {
        setConfirmError("There is a technical error while fetching the details. Please try again..!")
        return false
      }
      //console.log("toolTxnList previous=>",toolTxnList)
      // excluding DRAFT forms of other users to view
      toolTxnList = toolTxnList.filter( item => item.status !== approvalStages.draft ? item : item.initiator === appContext.user ? item : false)

      //console.log("toolTxnList filtered=>",toolTxnList)
      const displayList = toolTxnList.map(txnObj => {
        let txnForAction = {...txnObj}
        txnObj.actions = buildActions(txnForAction);
        delete txnObj.id
        delete txnObj.nondeclared
        delete txnObj.transactionid
        delete txnObj.rejectedreason
        return txnObj
      })

      //console.log("displayList==>",displayList)
      setDeclaredToolData(displayList)
  }

  useEffect(() => {
    setLoading(true);    
    const buildData = async () => {
      // set Table Headers            
      await getTransactionOnLoadData()
      setLoading(false);    
    };
    buildData();
  },[]);

  return (
    <Form>            
      
      <div className="topBtnDivTxn">
        <Row form style={{ justifyContent: "flex-end" }}>
          <Col md="auto">
            <Alert color="info" isOpen={true} style={{fontSize:"12px", textAlign: "left"}}>
              {generalConstants.disclaimer}<br/>{generalConstants.disclaimer2}
            </Alert>
          </Col>
          <Col md="auto">
              <BackButton path="/toolsalesform" label="Go Back To Sales Home"/>
          </Col>
          <Col md="auto">              
            <ToolSalesButton onClick={() =>setDisplaySearchDiv(!displaySearchDiv) } ><FaSearch style={{ fontSize: "20px"}}/>&nbsp;&nbsp;Search Tool Status</ToolSalesButton>              
          </Col>            
        </Row>
      </div>
      <Alert color="danger" isOpen={confirmError != null ? true : false} toggle={()=> setConfirmError(null)}>
        {confirmError}
      </Alert>
      <Alert color="success" isOpen={successAlert != null ? true : false} toggle={()=> setSuccessAlert(null)}>
        {successAlert}
      </Alert>
      <LoadingModal open={loading} msg="Loading..." />
      <DeleteAlertModal open={deleteModal} handler={setDeleteModal} deleteHandler={deleteAction.bind(this,row)}/>
      <div className={"form"}>
        
      <Collapse in={displaySearchDiv}>
        <div className="mainTST">
            <br/>
            <ToolStatusSearch
                  setDis={setDisplaySearchDiv}
                  //submithandler={submitAddToolhandler}
                  stateVals={stateValues}
                  toolList={toolList}
                  closeHandler={toggleModal}
                />
          </div>
      </Collapse>
      
        <div className="mainTST">
          {declaredToolData.length !== 0 ? (
            <ReactTable
            data={declaredToolData}
            columns={columns}
            defaultPageSize={declaredToolData.length>5?20:5}
            // style={{
            //   height: "420px" // This will force the table body to overflow and scroll, since there is not enough room
            // }}
            defaultSorted={[
              {
                  id: "date",
                  desc: true
              }
            ]}
            className="-striped -highlight"
        />
          ):(<div className={"noDataDiv"}>
          <p>No data Found.!</p>
        </div>)}
            
        </div>
        <Alert color="danger" isOpen={confirmError != null ? true : false}>
          {confirmError}
        </Alert>
      </div>
    </Form>
  );
};

export default ToolSalesTransactions;
